import { render, staticRenderFns } from "./MiniProgramHomepage.vue?vue&type=template&id=22806c71&scoped=true"
import script from "./MiniProgramHomepage.vue?vue&type=script&lang=js"
export * from "./MiniProgramHomepage.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramHomepage.vue?vue&type=style&index=0&id=22806c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22806c71",
  null
  
)

export default component.exports